<div class="content-group">
      <div class="row">
        <div class="col-lg-8">
      <ng-container *ngIf="atsDto">
        <app-phx-panel>
          <div class="form-horizontal">
            <app-ats-row>
              <div primary class="d-flex">
                <h4 class="flex-grow-1">ATS Placement</h4>
                <button type="button"
                  *ngIf="hasExtraFields"
                  class="btn btn-link"
                  (click)="showAllAtsFields = !showAllAtsFields">
                  {{showAllAtsFields ? 'Hide extra fields' : 'Show all fields'}}
                </button>
              </div>
              <h4 secondary>FBO Records</h4>
            </app-ats-row>
      
            <app-ats-row>
              <app-ats-field
                primary
                label="Source"
                [value]="atsDto.AtsSourceId | CodeValue:codeValueGroups.AtsSource">
              </app-ats-field>

              <ng-container secondary *ngTemplateOutlet="atsRowCheckmark"></ng-container>
            </app-ats-row>
            
            <app-ats-row>
              <app-ats-field
                primary
                label="Placement"
                [value]="[atsDto.AtsPlacementId, atsDto.AtsPlacement.Status]"
                separator=" - ">
              </app-ats-field>

              <ng-container secondary *ngTemplateOutlet="atsRowCheckmark"></ng-container>
            </app-ats-row>
        
            <app-ats-row>
              <app-ats-field
                primary
                label="Start Date"
                [value]="atsDto.AtsPlacement.StartDate | date: phxConstants.DateFormat.mediumDate">
              </app-ats-field>

              <ng-container secondary *ngTemplateOutlet="atsRowCheckmark"></ng-container>
            </app-ats-row>
        
            <app-ats-row *ngIf="atsDto.AtsPlacement.EndDate">
              <app-ats-field
                primary
                label="End Date"
                [value]="atsDto.AtsPlacement.EndDate | date: phxConstants.DateFormat.mediumDate">
              </app-ats-field>

              <ng-container secondary *ngTemplateOutlet="atsRowCheckmark"></ng-container>
            </app-ats-row>
        
            <app-ats-row>
              <app-ats-field
                primary
                label="Placement Type"
                [value]="atsDto.AtsPlacement.PlacementType | spoofValueForTenant : { substituteFor: 'Regular', forTenant: 'Demo' }">
              </app-ats-field>
        
              <app-ats-field
                secondary
                label="Line Of Business"
                [value]="atsDto.AtsPlacement.LineOfBusinessId | CodeValue:codeValueGroups.LineOfBusiness">
              </app-ats-field>
            </app-ats-row>
        
            <app-ats-row *ngIf="shouldShowField('JobTitle')">
              <app-ats-field
                primary
                label="Job Title"
                [value]="atsDto.AtsPlacement.JobTitle">
              </app-ats-field>

              <ng-container secondary *ngTemplateOutlet="atsRowCheckmark"></ng-container>
            </app-ats-row>
        
            <app-ats-row *ngIf="shouldShowField('JobFunction')">
              <app-ats-field
                primary
                label="Job Function"
                [value]="atsDto.AtsPlacement.JobFunction">
              </app-ats-field>
        
              <app-ats-field
                secondary
                label="Job Function"
                [value]="atsDto.JobFunctionId | CodeValue:codeValueGroups.JobFunction">
              </app-ats-field>
            </app-ats-row>
        
            <app-ats-row *ngIf="shouldShowField('Hours')">
              <app-ats-field
                primary
                label="Hours"
                [value]="atsDto.AtsPlacement.Hours">
              </app-ats-field>

              <ng-container secondary *ngTemplateOutlet="atsRowCheckmark"></ng-container>
            </app-ats-row>

            <app-ats-row *ngIf="shouldShowField('ClientWorksiteSubdivision')">
              <app-ats-field
                primary
                label="Client Worksite"
                [value]="[atsDto.AtsPlacement.ClientWorksiteCity, atsDto.AtsPlacement.ClientWorksiteSubdivision, atsDto.AtsPlacement.ClientWorksiteCountry]"
                separator=", ">
              </app-ats-field>
        
              <app-ats-field
                secondary
                label="Client Worksite"
                [value]="atsDto.WorksiteId | CodeValue:codeValueGroups.Worksite">
              </app-ats-field>
            </app-ats-row>
        
            <app-ats-row *ngIf="shouldShowField('WorkerLocationSubdivision')">
              <app-ats-field
                primary
                label="Worker Location"
                [value]="[atsDto.AtsPlacement.WorkerLocationSubdivision, atsDto.AtsPlacement.WorkerLocationCountry]"
                separator=", ">
              </app-ats-field>
        
              <app-ats-field
                secondary
                label="Worker Location"
                [value]="atsDto.WorkerLocationId | CodeValue:codeValueGroups.Subdivision">
              </app-ats-field>
            </app-ats-row>

            <app-ats-row *ngIf="shouldShowField('BillingCurrency')">
              <app-ats-field
                primary
                label="Billing Currency"
                [value]="atsDto.AtsPlacement.BillingCurrency">
              </app-ats-field>

              <app-ats-field
                secondary
                label="Billing Currency"
                [value]="atsDto.AtsPlacement.BillingCurrency | CodeValueByCode:codeValueGroups.Currency">
              </app-ats-field>
            </app-ats-row>
        
            <ng-container *ngFor="let rate of atsDto.BillingRates; let idx = index">
              <app-ats-row>
                <app-ats-field
                  primary
                  label="{{rate.RateTypeId | CodeValue:codeValueGroups.RateType}} Billing Rate"
                  [value]="['$', rate.Rate | number : '1.2-2', atsDto.AtsPlacement.BillingRateUnitId | CodeValue:codeValueGroups.RateUnit]"
                  separator=" ">
                </app-ats-field>

                <ng-container secondary *ngTemplateOutlet="atsRowCheckmark"></ng-container>
              </app-ats-row>
            </ng-container>

            <app-ats-row *ngIf="shouldShowField('PaymentCurrency')">
              <app-ats-field
                primary
                label="Payment Currency"
                [value]="atsDto.AtsPlacement.PaymentCurrency">
              </app-ats-field>

              <app-ats-field
                secondary
                label="Payment Currency"
                [value]="atsDto.AtsPlacement.PaymentCurrency | CodeValueByCode:codeValueGroups.Currency">
              </app-ats-field>
            </app-ats-row>
        
            <ng-container *ngFor="let rate of atsDto.PaymentRates; let idx = index">
              <app-ats-row>
                <app-ats-field
                  primary
                  label="{{rate.RateTypeId | CodeValue:codeValueGroups.RateType}} Payment Rate"
                  [value]="['$', rate.Rate | number : '1.2-2', atsDto.AtsPlacement.PaymentRateUnitId | CodeValue:codeValueGroups.RateUnit]"
                  separator=" ">
                </app-ats-field>

                <ng-container secondary *ngTemplateOutlet="atsRowCheckmark"></ng-container>
              </app-ats-row>
            </ng-container>
        
            <app-ats-row *ngIf="shouldShowField('JobOwner')">
              <app-ats-field
                primary
                label="{{atsOwnerLabel}} (Job)"
                [value]="[atsDto.AtsPlacement.JobOwner?.Id, atsDto.AtsPlacement.JobOwner | atsPerson]"
                [emptyText]="notFoundInAts"
              ></app-ats-field>
        
              <app-ats-field
                secondary
                label="Job Owner"
                [value]="[atsDto.FboJobOwnerUserProfileId || null, atsDto.FboJobOwnerName]"
                separator=" - "
                [emptyText]="entityNotFoundWarning"
                [warning]="atsDto.FboJobOwnerIsActive ? null : profileInactiveWarning"
              ></app-ats-field>
            </app-ats-row>
        
            <app-ats-row *ngIf="atsDto.AtsPlacement.Recruiter1 && shouldShowField('Recruiter1')">
              <app-ats-field
                primary
                label="Recruiter"
                [value]="[atsDto.AtsPlacement.Recruiter1?.Id, atsDto.AtsPlacement.Recruiter1 | atsPerson]"
                [emptyText]="notFoundInAts">
              </app-ats-field>
        
              <app-ats-field
                secondary
                label="Recruiter"
                [value]="[atsDto.FboRecruiter1?.UserProfileId, atsDto.FboRecruiter1?.Name]"
                separator=" - "
                [emptyText]="entityNotFoundWarning"
                [warning]="atsDto.FboRecruiter1?.IsActive ? null : profileInactiveWarning"
              ></app-ats-field>
            </app-ats-row>

            <app-ats-row *ngIf="atsDto.AtsPlacement.Recruiter2 && shouldShowField('Recruiter2')">
              <app-ats-field
                primary
                label="Recruiter 2"
                [value]="[atsDto.AtsPlacement.Recruiter2?.Id, atsDto.AtsPlacement.Recruiter2 | atsPerson]"
                [emptyText]="notFoundInAts">
              </app-ats-field>
        
              <app-ats-field
                secondary
                label="Recruiter 2"
                [value]="[atsDto.FboRecruiter2?.UserProfileId, atsDto.FboRecruiter2?.Name]"
                separator=" - "
                [emptyText]="entityNotFoundWarning"
                [warning]="atsDto.FboRecruiter2?.IsActive ? null : profileInactiveWarning"
              ></app-ats-field>
            </app-ats-row>

            <app-ats-row *ngIf="atsDto.AtsPlacement.SupportingJobOwner1 && shouldShowField('SupportingJobOwner1')">
              <app-ats-field
                primary
                label="Supporting Job Owner"
                [value]="[atsDto.AtsPlacement.SupportingJobOwner1?.Id, atsDto.AtsPlacement.SupportingJobOwner1 | atsPerson]"
                [emptyText]="notFoundInAts">
              </app-ats-field>
        
              <app-ats-field
                secondary
                label="Supporting Job Owner"
                [value]="[atsDto.FboSupportingJobOwner1?.UserProfileId, atsDto.FboSupportingJobOwner1?.Name]"
                separator=" - "
                [emptyText]="entityNotFoundWarning"
                [warning]="atsDto.FboSupportingJobOwner1?.IsActive ? null : profileInactiveWarning"
              ></app-ats-field>
            </app-ats-row>

            <app-ats-row *ngIf="atsDto.AtsPlacement.SupportingJobOwner2 && shouldShowField('SupportingJobOwner2')">
              <app-ats-field
                primary
                label="Supporting Job Owner 2"
                [value]="[atsDto.AtsPlacement.SupportingJobOwner2?.Id, atsDto.AtsPlacement.SupportingJobOwner2 | atsPerson]"
                [emptyText]="notFoundInAts">
              </app-ats-field>
        
              <app-ats-field
                secondary
                label="Supporting Job Owner 2"
                [value]="[atsDto.FboSupportingJobOwner2?.UserProfileId, atsDto.FboSupportingJobOwner2?.Name]"
                separator=" - "
                [emptyText]="entityNotFoundWarning"
                [warning]="atsDto.FboSupportingJobOwner2?.IsActive ? null : profileInactiveWarning"
              ></app-ats-field>
            </app-ats-row>
            
            <app-ats-row *ngIf="atsDto.AtsPlacement.ClientId && shouldShowField('ClientId')">
              <app-ats-field
                primary
                label="Client Company"
                [value]="[atsDto.AtsPlacement.ClientId, atsDto.AtsPlacement.ClientDisplayName]">
              </app-ats-field>
        
              <app-ats-field
                secondary
                label="Client Company"
                [value]="[atsDto.SuggestedOrganizationIdClient, atsDto.SuggestedOrganizationClientLegalName]"
                separator=" - "
                [emptyText]="entityNotFoundWarning"
              ></app-ats-field>
            </app-ats-row>
        
            <app-ats-row *ngIf="atsDto.AtsPlacement.Worker && shouldShowField('Worker')">
              <app-ats-field
                primary
                label="User Profile Worker"
                [value]="[atsDto.AtsPlacement.Worker.Id, atsDto.AtsPlacement.Worker | atsPerson]"
                [emptyText]="notFoundInAts">
              </app-ats-field>
        
              <app-ats-field
                secondary
                label="User Profile Worker"
                [value]="[atsDto.SuggestedUserProfileIdWorker, atsDto.SuggestedUserProfileWorkerName]"
                separator=" - "
                [emptyText]="entityNotFoundWarning"
              ></app-ats-field>
            </app-ats-row>
        
            <app-ats-row *ngIf="atsDto.AtsPlacement.ClientManager && shouldShowField('ClientManager')">
              <app-ats-field
                primary
                label="Client Manager"
                [value]="[atsDto.AtsPlacement.ClientManager?.Id, atsDto.AtsPlacement.ClientManager | atsPerson]"
                [emptyText]="notFoundInAts"
              ></app-ats-field>
        
              <app-ats-field
                secondary
                label="Client Manager"
                [value]="[atsDto.FboClientManagerUserProfileId || null, atsDto.FboClientManagerName]"
                separator=" - "
                [emptyText]="entityNotFoundWarning"
                [warning]="atsDto.FboClientManagerIsActive ? null : profileInactiveWarning"
              ></app-ats-field>
            </app-ats-row>

            <app-ats-row *ngIf="atsDto.AtsPlacement.TimesheetMethodologyId && shouldShowField('TimesheetMethodologyId')">
              <app-ats-field
                primary
                label="Timesheet Methodology"
                [value]="atsDto.AtsPlacement.TimesheetMethodologyId | CodeValue:codeValueGroups.TimeSheetMethodology">
              </app-ats-field>

              <ng-container secondary *ngTemplateOutlet="atsRowCheckmark"></ng-container>
            </app-ats-row>
        
            <app-ats-row *ngIf="atsDto.AtsPlacement.TimesheetClientApprover && shouldShowField('TimesheetClientApprover')">
              <app-ats-field
                primary
                label="Timesheet Client Approver"
                [value]="[atsDto.AtsPlacement.TimesheetClientApprover.Id, atsDto.AtsPlacement.TimesheetClientApprover | atsPerson]"
                [emptyText]="notFoundInAts">
              </app-ats-field>
        
              <app-ats-field
                secondary
                label="Timesheet Client Approver"
                [value]="[atsDto.FboTimesheetClientApproverProfileId || null, atsDto.FboTimesheetClientApproverName]"
                separator=" - "
                [emptyText]="entityNotFoundWarning"
                [warning]="atsDto.FboTimesheetClientApproverIsActive ? null : profileInactiveWarning"
              ></app-ats-field>
            </app-ats-row>

            <app-ats-row *ngIf="atsDto.AtsPlacement.TimesheetInternalApprover && shouldShowField('TimesheetInternalApprover')">
              <app-ats-field
                primary
                label="Timesheet Internal Approver"
                [value]="[atsDto.AtsPlacement.TimesheetInternalApprover.Id, atsDto.AtsPlacement.TimesheetInternalApprover | atsPerson]"
                [emptyText]="notFoundInAts">
              </app-ats-field>
        
              <app-ats-field
                secondary
                label="Timesheet Internal Approver"
                [value]="[atsDto.FboTimesheetInternalApproverProfileId || null, atsDto.FboTimesheetInternalApproverName]"
                separator=" - "
                [emptyText]="entityNotFoundWarning"
                [warning]="atsDto.FboTimesheetInternalApproverIsActive ? null : profileInactiveWarning"
              ></app-ats-field>
            </app-ats-row>

            <app-ats-row *ngIf="atsDto.AtsPlacement.BillingRecipient && shouldShowField('BillingRecipient')">
              <app-ats-field
                primary
                label="Billing Recipient"
                [value]="[atsDto.AtsPlacement.BillingRecipient.Id, atsDto.AtsPlacement.BillingRecipient | atsPerson]"
                [emptyText]="notFoundInAts">
              </app-ats-field>

              <app-ats-field
                secondary
                label="Billing Recipient"
                [value]="[atsDto.FboBillingRecipientUserProfileId || null, atsDto.FboBillingRecipientName]"
                separator=" - "
                [emptyText]="entityNotFoundWarning"
                [warning]="atsDto.FboBillingRecipientIsActive ? null : profileInactiveWarning"
              ></app-ats-field>
            </app-ats-row>
        
            <app-ats-row *ngIf="atsDto.AtsPlacement.ReferenceContact && shouldShowField('ReferenceContact')">
              <app-ats-field
                primary
                label="Reference Contact"
                [value]="[atsDto.AtsPlacement.ReferenceContact.Id, atsDto.AtsPlacement.ReferenceContact | atsPerson]"
                [emptyText]="notFoundInAts">
              </app-ats-field>
        
              <app-ats-field
                secondary
                label="Reference Contact"
                [value]="[atsDto.FboReferenceContactUserProfileId || null, atsDto.FboReferenceContactName]"
                separator=" - "
                [emptyText]="entityNotFoundWarning"
                [warning]="atsDto.FboReferenceContactIsActive ? null : profileInactiveWarning"
              ></app-ats-field>
            </app-ats-row>
          </div>
        </app-phx-panel>
      </ng-container>
            </div>
          </div>
  <div class="row">
    <div class="col-lg-8">
      <ng-container *ngIf="inputFormGroup">
        <form [formGroup]="inputFormGroup" class="form-horizontal">
          <ng-container *ngIf="!workOrderCreateInProgress">
            <phx-form-control
              [control]="inputFormGroup.controls.OrganizationIdClient"
              [labelText]="atsDto.MappedOrganizationIdClients?.length === 1 ? 'Mapped Client Company' : 'Work Order Client Company'"
              [editable]="atsDto.MappedOrganizationIdClients?.length !== 1"
              [viewModeText]="inputFormGroup.controls.OrganizationIdClient.value | lookup:listOrganizationClient:'Id':'DisplayText'"
              >
              <app-phx-select-box [items]="listOrganizationClient" textField="DisplayText" valueField="Id"
                formControlName="OrganizationIdClient">
              </app-phx-select-box>
            </phx-form-control>
  
            <phx-form-control [control]="inputFormGroup.controls.TemplateId" labelText="Work Order Template" [editable]="true">
              <app-phx-select-box [items]="listFilteredWorkOrderTemplates" textField="DisplayValue" valueField="Id"
                formControlName="TemplateId">
              </app-phx-select-box>
            </phx-form-control>
  
            <phx-form-control
              [control]="inputFormGroup.controls.UserProfileIdWorker"
              labelText="Work Order User Profile Worker"
              [editable]="true"
              viewModeText="{{inputFormGroup.controls.UserProfileIdWorker.value}} -
              {{inputFormGroup.controls.UserProfileIdWorker.value | lookup:listUserProfileWorker:'Id':'Contact.FullName'}}"
              >
                <app-phx-select-box-w-tooltip 
                  [items]="listUserProfileWorker" 
                  textField="DisplayValue" 
                  valueField="Id"
                  formControlName="UserProfileIdWorker">
                    <ng-template let-item>
                        <table>
                            <ng-container *ngFor="let field of tooltipFields">
                                <tr>
                                    <td class="text-left prm f12c">{{field.label}}:</td>
                                    <td class="text-left f12c">{{item[field.value] || '-'}}</td>
                                </tr>
                            </ng-container>
                        </table>
                    </ng-template>
                </app-phx-select-box-w-tooltip>
                <div *ngIf="atsDto.SuggestedUserProfileIdWorker && selectedProfileWorker" class="selected-profile-worker-box">
                    <div class="row">
                        <div class="col-lg-12">
                            <a routerLink="{{selectedProfileWorkerUrlLink}}" target="_blank">
                                {{selectedProfileWorker.DisplayValue}}
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 bold-thin">Email:</div>
                        <div class="col-lg-9">{{selectedProfileWorker.PrimaryEmail}}</div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 bold-thin">Organization:</div>
                        <div class="col-lg-9">{{selectedProfileWorker.OrganizationName || '-'}}</div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 bold-thin">Update Date:</div>
                        <div class="col-lg-9">{{selectedProfileWorker.LastModifiedDatetime}}</div>
                    </div>
                </div>
            </phx-form-control>
          </ng-container>
          <div class="panel-footer">
    <div class="row">
      <div class="col-lg-6"></div>
      <div class="col-lg-6">
        <div class="pull-right">
                  <button 
                    type="button"
                    class="btn btn-primary"
                    (click)="validateLOBAndSubmit()" 
                    [disabled]="!inputFormGroup.valid || ValidationMessages?.ValidationMessages?.length > 0 || workOrderCreateInProgress">
                    Next
                  </button>
        </div>
      </div>
    </div>
  </div>
  
  <app-phx-validation-messages [messages]="ValidationMessages"></app-phx-validation-messages>
</form>
      </ng-container>
    </div>
  </div>
</div>
<app-phx-dialog [config]="phxDialogComponentConfigModel"></app-phx-dialog>

<ng-template #atsRowCheckmark>
  <div class="row">
    <div class="col-lg-4"></div>
    <div class="col-lg-6">
      <i class="material-icons fieldViewMode form-control-static">check</i>
    </div>
  </div>
</ng-template>